import SharedDateInput from '../shared/DateInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/homePersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface HomeDateInputProps {
  label: string;
  date: Date;
  onChange: any;
  section: number;
  required?: boolean;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  subLabel?: string;
  disabled?: boolean;
  isClearable?: boolean;
}

const HomeDateInput = (props: HomeDateInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
  };

  return (
    <SharedDateInput
      {...props}
      formStateKey="homePersonalForm"
      formActions={formActions}
    />
  );
};

export default HomeDateInput;
